import React from 'react'
import { useStore } from '../../StateProvider'
import { TierFormNoSteps } from './TierFormNoSteps/TierFormNoSteps'
import { TierFormWithSteps } from './TierFormWithSteps/TierFormWithSteps'
import { TierFormNoStepsJoint } from './TierFormNoStepsJoint/TierFormNoStepsJoint'
import { TierFormStepsJoint } from './TierFormStepsJoint/TierFormStepsJoint'

const TierForm = ({ isLoadingSubmit, onSubmit, buttonName, onSubmitJoint }) => {
  const [{ whitelabel: { steps }, user: { isJointAccount } }] = useStore()

  if (steps.length > 0 && !isJointAccount) {
    return (
      <TierFormWithSteps
        isLoadingSubmit={isLoadingSubmit}
        onSubmit={onSubmit}
        buttonName={buttonName}
      />
    )
  } else if (steps.length === 0 && !isJointAccount) {
    return (
      <TierFormNoSteps
        isLoadingSubmit={isLoadingSubmit}
        onSubmit={onSubmit}
        buttonName={buttonName}
      />
    )
  } else if (steps.length === 0 && isJointAccount) {
    return (
      <TierFormNoStepsJoint
        isLoadingSubmit={isLoadingSubmit}
        onSubmit={onSubmit}
        onSubmitJoint={onSubmitJoint}
        buttonName={buttonName}
      />
    )
  } else if (steps.length > 0 && isJointAccount) {
    return (
      <TierFormStepsJoint
        isLoadingSubmit={isLoadingSubmit}
        onSubmit={onSubmit}
        onSubmitJoint={onSubmitJoint}
        buttonName={buttonName}
      />
    )
  }
}

export { TierForm }
